import { CardData } from "./cardData";
import { ContractsTypes } from "./enums/contractsTypes";
import { parseDate } from "../utilities/parseHelper";
import { DateType } from "./types/index";

/**  Данные договора-счета. */
export class ContractData {
  /** Акутальная дата. */
  public ActualDate: DateType = null;

  /** Алиас */
  public Alias: string = "";

  /** Возможность пополнения. */
  public CanDeposit: boolean = false;

  /** Ограничения пополнения. */
  public RemCanDeposit: string = "";

  /** Признак возможности досрочного погашения кредита. */
  public CanEarlyRepay: boolean = false;

  /** Возможность списания. */
  public CanWithdraw: boolean = false;

  /** Ограничения списания. */
  public RemCanWithdraw: string = "";

  /** Наличие капитализации. */
  public Capitalization: boolean = false;

  /** Список прилинкованных карт. */
  public Cards: Array<CardData> = [];

  /** Тип договора. */
  public ContractType: ContractsTypes = ContractsTypes.None;

  /** Наименование вида договора. */
  public ContractTypeName: string = "";

  /** Код валюты (RUR, USD и т.д.). */
  public CurrencyCharCode: string = "";

  /** Дата закрытия. */
  public DateClose: DateType = null;

  /** Дата запланированного окончания. */
  public DateEnd: DateType = null;

  /**  Дата открытия. */
  public DateOpen: DateType = null;

  /**  Наименование договора. */
  public DepositName: string = "";

  /**  Сумма депозита. */
  public DepositSum: number = 0;

  /**  Отображаемое имя. */
  public DisplayName: string = "";

  /**  Доступно к снятию. */
  public DisposableLimit: number = 0;

  /**  */
  public DisposableLimitProc: number = 0;

  /** Кредитный лимит. */
  public FullLimit: number = 0;

  /** */
  public FutureIncomeSum: number = 0;

  /** */
  public GraceEndDate: DateType = null;

  /** */
  public GraceOutstandingDate: DateType | string = null;

  /** */
  public GraceRepaidSum: number = 0;

  /** */
  public GraceSum: number = 0;

  /** Идентификатор в ДБО. */
  public Id: number = -1;

  /** */
  public IncomeSum: number = 0;

  /** */
  public LinkedDepositAccountNum: string = "";

  /** Основной счет. */
  public MainAccount: string = "";

  /** */
  public MinPayDate: DateType = null;

  /** */
  public MinPayRepaidSum: number = 0;

  /** Минимальная сумма платежа. */
  public MinPaySum: number = 0;

  /** Cумма очередного платежа по основному долгу. */
  public MinPaySumMain: number = 0;

  /** Cумма очередного платежа по процентам. */
  public MinPaySumPercents: number = 0;

  /** Остаток задолженности на текущую дату по процентам. */
  public RestAcntPercents: number = 0;
  /**  */
  public NonExecDraftSum: number = 0;

  /** Арестованная сумма (является частью рассчитываемых заблокированных на счете). */
  public ArrestSum: number = 0;

  /** Номер договора. */
  public Number: string = "";

  /**  Задолженность по кредиту. */
  public OutstandingSum: number = 0;

  /**  Основной долг по кредиту. */
  public OutstandingSumMain: number = 0;

  /**  Проценты по кредиту. */
  public OutstandingSumPrc: number = 0;

  /**  Прсрочка кредита */
  public OutstandingDate: DateType = null;

  /**  Дата открытия овера. */
  public OverdraftCloseDate: DateType = null;

  /**  Дата закрытия овера. */
  public OverdraftOpenDate: DateType = null;

  /**  Дата завершения действия лимита. */
  public OverdraftEndLimitDate: DateType = null;

  /**  Дата планируемого закрытия овера. */
  public OverdraftExpirationDate: DateType = null;

  /**  Дата планируемого закрытия овера. */
  public PayPercentsPeriod: string = "";

  /**  Сумма штрафа. */
  public PenaltySum: number = 0;

  /**  Процентная ставка. */
  public PercentRate: number = 0;

  /** Дата начала цикла последнего вклада под проценты. */
  public RangeFrom: DateType = null;

  /** Дата завершения цикла последнего вклада под проценты. */
  public RangeTo: DateType = null;

  /** ИД в Retail. */
  public ReferenceId: string = "";

  /** Остаток на счете. */
  public Rest: number = 0;

  /** Остаточные кредитные средства. */
  public UnusedLimit: number = 0;

  /** Минимальный остаток на счете. */
  public MinDepositRest: number = 0;

  /**  Не просроченные проценты по непросроченной ссуде. */
  public PercOnMainSum: number = 0;

  /**  Просроченные проценты по непросроченной ссуде. */
  public OutPercOnMainSum: number = 0;

  /**  Дата последнего расчета процентов. */
  public PercChargeDate: DateType = null;

  /**   Скрытый. */
  public Hidden: boolean = false;

  /**   Поручитель по кредиту. */
  public Guarantor: string = "";

  /**   Поручитель по кредиту. */
  public Pledge: string = "";

  /**   Дата очередного страхового платежа. */
  public DateInsurance: DateType = null;

  /**   Сумма очередного страхового платежа. */
  public AmountInsurance: number = 0;

  /**   Пакет SMS информирования. */
  public SmsPacketId: string = "";

  /**   Заблокировано на счете (TWO Fimi). */
  public DebitHold: number = 0;
  
  public MaxDepositSum: number = 0;

  public MinDepositAmount: number = 0;

  public SpecialConditions: string = ''

  public Comment: string = ''

  public DepositPeriod: string = ''

  public IsCapitalization: string = ''

  public OpenCredit: string = "";

  /**   Ставка при досрочном изъятии. */
  public EarlyPercent: string = '';

  public IsVisibleCreateVirtualCard: boolean = false;

  private CustomFields: Array<string> = [
    'MaxDepositSum', 
    'SpecialConditions', 
    'Comment', 
    'DepositPeriod', 
    'IsCapitalization', 
    'MinDepositRest', 
    'EarlyPercent', 
    'MinDepositAmount', 
    'OpenCredit', 
    'IsVisibleCreateVirtualCard'
  ];

  /**
   * Конструктор с загрузкой данных с сервера.
   * @param src Источник данных.
   */
  constructor(src: any = null) {
    if (src) {
      const sXml: string = src.CustomFields ?? "";

      // Парсим XML.
      const parser = new DOMParser();
      const xDoc = parser.parseFromString(sXml, "text/xml");

      const xmlFields = xDoc.getElementsByTagName('Field');
      this.Id = src.Id ?? -1;
      this.ReferenceId = src.ReferenceId ?? "";
      this.ActualDate = parseDate(src.ActualDate);
      this.Alias = src.Alias ?? "";
      this.Number = src.Number ?? "";
      this.MainAccount = src.MainAccount ?? "";
      this.CanDeposit = src.CanDeposit ?? false;
      this.CanWithdraw = src.CanWithdraw ?? false;
      this.Capitalization = src.Capitalization ?? false;
      this.ContractTypeName = src.ContractTypeName ?? "";
      this.DepositName = src.DepositName ?? "";
      this.CurrencyCharCode = src.CurrencyCharCode ?? "";
      this.ContractType = (src.ContractType ?? 0) as ContractsTypes;
      this.DateOpen = parseDate(src.DateOpen);
      this.DateClose = parseDate(src.DateClose);
      this.DateEnd = parseDate(src.DateEnd);
      this.DisplayName = src.DisplayName ?? "";
      this.Rest = src.Rest ?? 0;
      this.PercentRate = src.PercentRate ?? 0;
      this.RangeFrom = parseDate(src.RangeFrom);
      this.RangeTo = parseDate(src.RangeTo);
      this.FullLimit = src.FullLimit ?? 0;
      this.UnusedLimit = src.UnusedLimit ?? 0;
      this.NonExecDraftSum = src.NonExecDraftSum ?? 0;
      this.ArrestSum = src.ArrestSum ?? 0;
      this.MinPayDate = parseDate(src.MinPayDate);
      this.MinPaySum = src.MinPaySum ?? 0;
      this.MinPaySumMain = src.MinPaySumMain ?? 0;
      this.MinPaySumPercents = src.MinPaySumPercents ?? 0;
      this.RestAcntPercents = src.RestAcntPercents ?? 0;
      this.OutstandingSum = src.OutstandingSum ?? 0;
      this.PenaltySum = src.PenaltySum ?? 0;
      this.DepositSum = src.DepositSum ?? 0;
      this.CanEarlyRepay = src.CanEarlyRepay ?? false;
      this.OutstandingSumMain = src.OutstandingSumMain ?? 0;
      this.OutstandingSumPrc = src.OutstandingSumPrc ?? 0;
      this.DisposableLimit = src.DisposableLimit ?? 0;
      this.DisposableLimitProc = src.DisposableLimitProc ?? 0;
      this.GraceSum = src.GraceSum ?? 0;
      this.GraceOutstandingDate = parseDate(src.GraceOutstandingDate);
      this.GraceRepaidSum = src.GraceRepaidSum ?? 0;
      this.GraceEndDate = parseDate(src.GraceEndDate);
      this.MinPayRepaidSum = src.MinPayRepaidSum ?? 0;
      this.PayPercentsPeriod = src.PayPercentsPeriod ?? "";
      this.IncomeSum = src.IncomeSum ?? 0;
      this.FutureIncomeSum = src.FutureIncomeSum ?? 0;
      this.OutstandingDate = parseDate(src.OutstandingDate);
      this.OverdraftOpenDate = parseDate(src.OverdraftOpenDate);
      this.OverdraftCloseDate = parseDate(src.OverdraftCloseDate);
      this.OverdraftEndLimitDate = parseDate(src.OverdraftEndLimitDate);
      this.OverdraftExpirationDate = parseDate(src.OverdraftExpirationDate);
      this.RemCanDeposit = src.RemCanDeposit ?? "";
      this.RemCanWithdraw = src.RemCanWithdraw ?? "";
      this.MinDepositRest = src.MinDepositRest ?? 0;
      this.PercOnMainSum = src.PercOnMainSum ?? 0;
      this.OutPercOnMainSum = src.OutPercOnMainSum ?? 0;
      this.PercChargeDate = parseDate(src.PercChargeDate);
      this.LinkedDepositAccountNum = src.LinkedDepositAccountNum ?? "";
      this.Hidden = src.Hidden ?? false;
      this.Guarantor = src.Guarantor ?? "";
      this.Pledge = src.Pledge ?? "";
      this.DateInsurance = parseDate(src.DateInsurance);
      this.AmountInsurance = src.AmountInsurance ?? 0;
      this.SmsPacketId = src.SmsPacketId?.toString() ?? "";
      this.DebitHold = src.DebitHold ?? 0;

      for(const j in this.CustomFields) {
        const key = this.CustomFields[j];
        for (let i = 0; i < xmlFields.length; i++) {
          const field = xmlFields[i];
          if (field.getAttribute('name') == key) {
            this[key] = field.getAttribute('value');
          }
          if (field.getAttribute('name') == 'GracePeriodText' && field.getAttribute('value')) {
            this.GraceOutstandingDate = field.getAttribute('value');
          }
        }
      }

      const cards = src.Cards;

      if (cards != null) {
        cards.forEach((card: any) => {
          this.Cards.push(new CardData(card));
        });
      }

      this.calc();
    }
  }

  // Вычислимые данные.

  /** Собственные средства. */
  public CalcEquity = 0;

  /** Кредитные средства. */
  public CalcCredit = 0;

  /** Использованные кредитные средства.*/
  public CalcUsedLimit = 0;

  /** Заблокированно на счёте. */
  public CalcLocked = 0;

  /** Производимые вычисления. */
  private calc(): void {
    ////////////////// - считаем доступный остаток
    if (this.ContractType == ContractsTypes.CardAccount) {
      const boofer: number = this.DisposableLimit < this.DisposableLimitProc ? this.DisposableLimit : this.DisposableLimitProc;
      this.DisposableLimit = ((boofer * 100) - (this.NonExecDraftSum * 100))/100;
    } else 
      this.DisposableLimit = ((this.DisposableLimit * 100) - (this.NonExecDraftSum * 100))/100;

    //////////////////

    ////////////////// - считаем собственные средства
    this.CalcEquity = ((this.Rest * 100) - (this.NonExecDraftSum * 100))/100;
    //////////////////

    ////////////////// - считаем использованные кредитные средства.
    this.CalcUsedLimit = this.FullLimit - this.UnusedLimit;
    //////////////////

    // регулировка использованных кредитных и собственных средств.
    if (this.CalcUsedLimit > 0 && this.CalcEquity > 0) {
      if (this.CalcUsedLimit - this.CalcEquity < 0) {
        this.CalcEquity -= this.CalcUsedLimit;
        this.CalcUsedLimit = 0;
      } else {
        this.CalcUsedLimit -= this.CalcEquity;
        this.CalcEquity = 0;
      }
    }

    ////////////////// - считаем кредитные
    this.CalcCredit = this.FullLimit - this.CalcUsedLimit;
    if (this.CalcCredit < 0) this.CalcCredit = 0;
    //////////////////

    ////////////////// - считаем заблокированно на счёте.
    if (this.FullLimit > 0)
      this.CalcLocked = this.Rest + this.CalcCredit - this.DisposableLimit;
    else this.CalcLocked = this.Rest - this.DisposableLimit;
    //////////////////
  }

  /**Обновить счет */
  public update(contract: ContractData): void {
    this.Id = contract.Id;
    this.ReferenceId = contract.ReferenceId;
    this.ActualDate = contract.ActualDate;
    this.Alias = contract.Alias;
    this.Number = contract.Number;
    this.MainAccount = contract.MainAccount;
    this.CanDeposit = contract.CanDeposit;
    this.CanWithdraw = contract.CanWithdraw;
    this.Capitalization = contract.Capitalization;
    this.ContractTypeName = contract.ContractTypeName;
    this.DepositName = contract.DepositName;
    this.CurrencyCharCode = contract.CurrencyCharCode;
    this.ContractType = contract.ContractType;
    this.DateOpen = contract.DateOpen;
    this.DateClose = contract.DateClose;
    this.DateEnd = contract.DateEnd;
    this.DisplayName = contract.DisplayName;
    this.Rest = contract.Rest;
    this.PercentRate = contract.PercentRate;
    this.RangeFrom = contract.RangeFrom;
    this.RangeTo = contract.RangeTo;
    this.FullLimit = contract.FullLimit;
    this.UnusedLimit = contract.UnusedLimit;
    this.NonExecDraftSum = contract.NonExecDraftSum;
    this.ArrestSum = contract.ArrestSum;
    this.MinPayDate = contract.MinPayDate;
    this.MinPaySum = contract.MinPaySum;
    this.MinPaySumMain = contract.MinPaySumMain;
    this.MinPaySumPercents = contract.MinPaySumPercents;
    this.RestAcntPercents = contract.RestAcntPercents;
    this.OutstandingSum = contract.OutstandingSum;
    this.PenaltySum = contract.PenaltySum;
    this.DepositSum = contract.DepositSum;
    this.CanEarlyRepay = contract.CanEarlyRepay;
    this.OutstandingSumMain = contract.OutstandingSumMain;
    this.OutstandingSumPrc = contract.OutstandingSumPrc;
    this.DisposableLimit = contract.DisposableLimit;
    this.DisposableLimitProc = contract.DisposableLimitProc;
    this.GraceSum = contract.GraceSum;
    this.GraceOutstandingDate = contract.GraceOutstandingDate;
    this.GraceRepaidSum = contract.GraceRepaidSum;
    this.GraceEndDate = contract.GraceEndDate;
    this.MinPayRepaidSum = contract.MinPayRepaidSum;
    this.PayPercentsPeriod = contract.PayPercentsPeriod;
    this.IncomeSum = contract.IncomeSum;
    this.FutureIncomeSum = contract.FutureIncomeSum;
    this.OutstandingDate = contract.OutstandingDate;
    this.OverdraftOpenDate = contract.OverdraftOpenDate;
    this.OverdraftCloseDate = contract.OverdraftCloseDate;
    this.OverdraftEndLimitDate = contract.OverdraftEndLimitDate;
    this.OverdraftExpirationDate = contract.OverdraftExpirationDate;
    this.RemCanDeposit = contract.RemCanDeposit;
    this.RemCanWithdraw = contract.RemCanWithdraw;
    this.MinDepositRest = contract.MinDepositRest;
    this.PercOnMainSum = contract.PercOnMainSum;
    this.OutPercOnMainSum = contract.OutPercOnMainSum;
    this.PercChargeDate = contract.PercChargeDate;
    this.LinkedDepositAccountNum = contract.LinkedDepositAccountNum;
    this.Hidden = contract.Hidden;
    this.Pledge = contract.Pledge;
    this.Guarantor = contract.Guarantor;
    this.DateInsurance = contract.DateInsurance;
    this.AmountInsurance = contract.AmountInsurance;
    this.SmsPacketId = contract.SmsPacketId;
    this.CalcEquity = contract.CalcEquity;
    this.CalcCredit = contract.CalcCredit;
    this.CalcUsedLimit = contract.CalcUsedLimit;
    this.CalcLocked = contract.CalcLocked;

    for (const j in this.CustomFields) {
      const key: string = this.CustomFields[j];
      if (contract[key])
        this[key] = contract[key];
    }

    if (contract.Cards) {
      contract.Cards.forEach(srcCard => {
        const card = this.Cards.find(c => {
          return c.Id == srcCard.Id;
        });

        if (card) {
          card.update(srcCard);
        }
      });
    }
  }
}
